import { Navigate, Route, useLocation } from 'react-router-dom';

/**
 * Back-office pages retired in W6 (DUP-7): the old address keeps working and
 * lands on the page that replaced it. The query string is kept, so a deep
 * link keeps its `?tab=`.
 *
 *   /AdminClientDetail → /AdminOrganisations (the tenant's identity lives there, ADR-031)
 *   /AdminCalendly     → /AdminOrganisations (customer.calendly_url is edited in the
 *                        dialer, Paramètres › Intégrations, by the tenant admin: DUP-1;
 *                        the platform key AdminSettings.calendly_url was read nowhere)
 *   /TwilioDiagnostic  → /TwilioConfig       (one health check, at the top of Twilio: DUP-5)
 */
export const PLATFORM_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/AdminClientDetail', to: '/AdminOrganisations' },
  { from: '/AdminCalendly', to: '/AdminOrganisations' },
  { from: '/TwilioDiagnostic', to: '/TwilioConfig' },
];

function KeepQueryNavigate({ to }: { to: string }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}

/** Route elements, to place inside <Routes>. */
export function platformRedirectRoutes() {
  return PLATFORM_REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<KeepQueryNavigate to={to} />} />
  ));
}
